/* Main App Component */

import { getAppLocation, setAppLocation, loadSavedUsers } from '../utils/storage';
import { LOCATION_ICONS } from '../utils/constants';
import React from 'react'; 


// Import components
import WelcomeScreen from './WelcomeScreen';
import EmployeeOptionsScreen from './EmployeeOptionsScreen';
import VisitorOptionsScreen from './VisitorOptionsScreen';
import SignInOutForm from './SignInOutForm';
import SuccessScreen from './SuccessScreen';
import LocationModal from './LocationModal';
import AuthModal from './AuthModal';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';



import '../css/dashboard.css'; 
import '../css/kiosk.css';


const SignInHomeScreen = () => {
  const nav = useNavigate();
  // State for navigation and screens
  const [currentScreen, setCurrentScreen] = React.useState('welcome');
  const [currentLocation, setCurrentLocation] = React.useState(getAppLocation());
  const [formData, setFormData] = React.useState({});
  
  // State for UI elements
  const [isAuthModalOpen, setIsAuthModalOpen] = React.useState(false);
  const [isLocationModalOpen, setIsLocationModalOpen] = React.useState(false);
  const [alert, setAlert] = React.useState('');
  const [users, setUsers] = React.useState(() => loadSavedUsers());
  

  const handleAuthenticate = () => {
    setIsAuthModalOpen(false);
    setIsLocationModalOpen(true);
  };
  
  
  // Handle location save
  const handleLocationChange = (location:string) => {
    // Save location using our storage utility
    setAppLocation(location);
    
    // Update the UI
    setCurrentLocation(location);
    
    // Show confirmation
    toast(`Location set to ${location}`);
  };

  const homeDisabled = () => {
    const isTablet = localStorage.getItem('isTablet');
    return isTablet === 'true' ? true : false;
  }
  
  // Render alert if present
  const renderAlert = () => {
    if (!alert) return null;
    
    return (
      <div className="alert-message">
        {alert}
      </div>
    );
  };
  
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', width: '100vw' }}>
      <header className="app-header">
        <div className="app-logo" >
          {homeDisabled() === false ? 
          <button className='home-link' style={{borderColor: 'transparent',}} onClick={()=> nav('/')}>Home</button>
          : null}
          Magni Sign In/Out
        </div>
        <div className="header-actions">
          <button 
            className="header-action" 
            onClick={() => setIsAuthModalOpen(true)}
          >
            Maintain
          </button>
        </div>
      </header>
      
      <main className="main-content">
        {renderAlert()}
        
        {currentScreen === 'welcome' && (
          <WelcomeScreen 
          />
        )}
        
        {currentScreen === 'employee-options' && (
          <EmployeeOptionsScreen 

          />
        )}
        
        {currentScreen === 'visitor-options' && (
          <VisitorOptionsScreen 

          />
        )}
        
        {['employee-sign-in', 'employee-sign-out', 'visitor-sign-in', 'visitor-sign-out', 'main-office-sign-out', 'visiting-office-sign-in'].includes(currentScreen) && (
          <SignInOutForm 
            currentLocation={currentLocation}
            formType={currentScreen}
          />
        )}
        
        {currentScreen === 'success' && (
          <SuccessScreen 
            data={formData}
          />
        )}

          <AuthModal 
            isOpen={isAuthModalOpen}
            onClose={() => setIsAuthModalOpen(false)}
            onAuthSuccess={handleAuthenticate}
          />

              
      <LocationModal 
        isOpen={isLocationModalOpen}
        onClose={() => setIsLocationModalOpen(false)}
        currentLocation={currentLocation}
        onLocationChange={handleLocationChange}
      />
      </main>
      
      <footer className="app-footer">
        Current Location: <span className="location-indicator">
          {LOCATION_ICONS[currentLocation]} {currentLocation}
        </span>
      </footer>


     
      
    </div>
  );
};

export default SignInHomeScreen;